import { createSlice } from "@reduxjs/toolkit"

interface ProviderProductionSummaryState {
  summaryGroupData: Array<any>
  selectedSummaryGroupData: any
  summaryRegionList: Array<any>
  summarySelectedRegion: any
  summaryPracticeData: Array<any>
  summarySelectedPractice: any
  practiceSummaryData: any
}

const initialState: ProviderProductionSummaryState = {
  summaryGroupData: [],
  selectedSummaryGroupData: null,
  summaryRegionList: [],
  summarySelectedRegion: null,
  summaryPracticeData: [],
  summarySelectedPractice: null,
  practiceSummaryData: null,
}

const providerProductionSummarySlice: any = createSlice({
  name: "providerProductionSummary",
  initialState,
  reducers: {
    setSummaryGroupData: (state, action) => {
      state.summaryGroupData = action.payload
    },
    setSelectedSummaryGroupData: (state, action) => {
      state.selectedSummaryGroupData = action.payload
    },
    setSummaryRegionList: (state, action) => {
      state.summaryRegionList = action.payload
    },
    setSummarySelectedRegion: (state, action) => {
      state.summarySelectedRegion = action.payload
    },
    setSummaryPracticeData: (state, action) => {
      state.summaryPracticeData = action.payload
    },
    setSummarySelectedPractice: (state, action) => {
      state.summarySelectedPractice = action.payload
    },
    setPracticeSummaryData: (state, action) => {
      state.practiceSummaryData = action.payload
    },
  },
})

export default providerProductionSummarySlice.reducer

export const {
  setSummaryGroupData,
  setSelectedSummaryGroupData,
  setSummaryRegionList,
  setSummarySelectedRegion,
  setSummaryPracticeData,
  setSummarySelectedPractice,
  setPracticeSummaryData,
} = providerProductionSummarySlice.actions
